import { FunctionColor, mediaMaxWidth, mediaMinWidth, Spacer, TitleFontSize } from '@lux/core';
import {
    ModalOverlay as ModalOverlayBackground,
    ModalTitle as LuxModalTitle,
    ModalMedia as LuxModalMedia,
    ModalDescription as LuxModalDescription,
} from '@lux/modal';

import styled from 'styled-components';

export const ModalOverlay = styled(ModalOverlayBackground)`
    ${mediaMaxWidth.sm} {
        display: flex;
        align-items: flex-end;
        position: fixed;
        bottom: 0;
        padding: 0;
        background-color: rgba(0, 0, 0, 0.5);
        justify-content: center;
        z-index: -1;

        & > [class*='ContentContainer'] {
            justify-content: flex-end;
        }
    }
`;

export const PlusBadgeWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${Spacer.XS};
    text-align: center;
    ${mediaMaxWidth.sm} {
        border-bottom: 1px solid ${FunctionColor.function20};
    }
`;

export const ModalWrapper = styled.div<{ isMember: boolean }>`
    display: flex;
    flex-direction: column;
    gap: ${Spacer.S};
    ${mediaMaxWidth.sm} {
        gap: ${Spacer.XS};
        ${props => props.isMember && `height: 50vh`};
        background-color: ${FunctionColor.function0};
        width: 100%;
        max-width: none;
        max-height: 80%;
        margin: 0 !important;
        overflow-y: auto;
        border-radius: 0;
        z-index: 1;

        & > [class*='ModalFooter'] {
            ${props =>
                props.isMember ? `padding: 0 ${Spacer.M};` : `padding: ${Spacer.M} ${Spacer.M};`};
        }

        & > [class*='ModalMedia'] {
            padding-top: ${Spacer.S};
        }
    }
`;

export const ModalTitle = styled(LuxModalTitle)`
    font-weight: 500;

    ${mediaMinWidth.sm} {
        font-size: ${TitleFontSize.S};
    }
    ${mediaMaxWidth.sm} {
        padding: 0 ${Spacer.M};
    }
`;

export const ModalDescription = styled(LuxModalDescription)`
    align-self: center;
    ${mediaMaxWidth.sm} {
        padding: 0 ${Spacer.M};
    }
`;
